export default "__VITE_ASSET__3cac923f__"